var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000450",
    d: "M2 2h20v2H2zM2 11h20v2H2zM2 19h20v2H2z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMiIgeT0iMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIiIGZpbGw9IiMwMDA0NTAiLz4KPHJlY3QgeD0iMiIgeT0iMTEiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyIiBmaWxsPSIjMDAwNDUwIi8+CjxyZWN0IHg9IjIiIHk9IjE5IiB3aWR0aD0iMjAiIGhlaWdodD0iMiIgZmlsbD0iIzAwMDQ1MCIvPgo8L3N2Zz4K";
export { SvgMenu as ReactComponent };